import { audio } from '../game/AudioManager.js';

export class HeartMiniGame {
  constructor(container, onComplete) {
    this.container = container;
    this.onComplete = onComplete;
    this.canvas = null;
    this.ctx = null;
    this.running = true;
    this.player = { x: 30, y: 30, size: 16, speed: 3 };
    this.fragments = [
      { x: 120, y: 80, collected: false },
      { x: 300, y: 150, collected: false },
      { x: 180, y: 280, collected: false }
    ];
    this.goal = { x: 420, y: 280, size: 24 };
    this.obstacles = [
      { x: 80, y: 0, w: 20, h: 180 },
      { x: 180, y: 120, w: 20, h: 220 },
      { x: 280, y: 0, w: 20, h: 180 },
      { x: 360, y: 120, w: 20, h: 220 }
    ];
    this.keys = {};
    this.animId = null;
    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div style="background:#0e0817; color:#fff; padding:10px; height:100%; display:flex; flex-direction:column; align-items:center;">
        <div style="display:flex; justify-content:space-between; width:100%; margin-bottom:8px;">
          <span style="font-weight:bold; color:#ff70a6;">HEART.EXE - Find Your Way</span>
          <button id="btn-skip-heart" style="background:#4a284e; color:#ffd166; border:1px solid #ff70a6; border-radius:4px; padding:2px 8px; cursor:pointer;">Skip Mini-game >></button>
        </div>
        <canvas id="heart-canvas" width="480" height="340" style="background:#170d26; border:2px solid #ff70a6; border-radius:4px;"></canvas>
        <div style="font-size:12px; color:#aaa; margin-top:6px;">Use [Arrow Keys] or [WASD] to guide Talha to Emily's Heart</div>
      </div>
    `;

    this.canvas = this.container.querySelector('#heart-canvas');
    this.ctx = this.canvas.getContext('2d');

    const skipBtn = this.container.querySelector('#btn-skip-heart');
    skipBtn.addEventListener('click', () => {
      this.winGame();
    });

    window.addEventListener('keydown', (e) => { this.keys[e.key.toLowerCase()] = true; });
    window.addEventListener('keyup', (e) => { this.keys[e.key.toLowerCase()] = false; });

    this.loop();
  }

  loop() {
    if (!this.running) return;
    this.update();
    this.render();
    this.animId = requestAnimationFrame(() => this.loop());
  }

  update() {
    let dx = 0;
    let dy = 0;
    if (this.keys['arrowleft'] || this.keys['a']) dx -= this.player.speed;
    if (this.keys['arrowright'] || this.keys['d']) dx += this.player.speed;
    if (this.keys['arrowup'] || this.keys['w']) dy -= this.player.speed;
    if (this.keys['arrowdown'] || this.keys['s']) dy += this.player.speed;

    const newX = this.player.x + dx;
    const newY = this.player.y + dy;

    // Check bounds
    if (newX >= 0 && newX <= this.canvas.width - this.player.size) {
      if (!this.checkWallCollision(newX, this.player.y)) {
        this.player.x = newX;
      }
    }
    if (newY >= 0 && newY <= this.canvas.height - this.player.size) {
      if (!this.checkWallCollision(this.player.x, newY)) {
        this.player.y = newY;
      }
    }

    // Check fragments
    this.fragments.forEach(f => {
      if (!f.collected && Math.hypot(this.player.x - f.x, this.player.y - f.y) < 20) {
        f.collected = true;
        audio.playClick();
      }
    });

    // Check goal
    if (Math.hypot(this.player.x - this.goal.x, this.player.y - this.goal.y) < 24) {
      this.winGame();
    }
  }

  checkWallCollision(px, py) {
    for (const w of this.obstacles) {
      if (
        px < w.x + w.w &&
        px + this.player.size > w.x &&
        py < w.y + w.h &&
        py + this.player.size > w.y
      ) {
        return true;
      }
    }
    return false;
  }

  render() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Walls
    this.ctx.fillStyle = '#4a284e';
    this.obstacles.forEach(w => {
      this.ctx.fillRect(w.x, w.y, w.w, w.h);
      this.ctx.strokeStyle = '#ff70a6';
      this.ctx.strokeRect(w.x, w.y, w.w, w.h);
    });

    // Memory fragments
    this.ctx.fillStyle = '#ffd166';
    this.fragments.forEach(f => {
      if (!f.collected) {
        this.ctx.beginPath();
        this.ctx.arc(f.x, f.y, 6, 0, Math.PI * 2);
        this.ctx.fill();
      }
    });

    // Final Glowing Heart Goal
    this.ctx.fillStyle = '#ff2a75';
    this.ctx.beginPath();
    const gx = this.goal.x, gy = this.goal.y;
    this.ctx.arc(gx - 6, gy - 6, 8, Math.PI, 0, false);
    this.ctx.arc(gx + 6, gy - 6, 8, Math.PI, 0, false);
    this.ctx.lineTo(gx, gy + 12);
    this.ctx.closePath();
    this.ctx.fill();

    // Player avatar
    this.ctx.fillStyle = '#38bdf8';
    this.ctx.fillRect(this.player.x, this.player.y, this.player.size, this.player.size);
  }

  winGame() {
    if (!this.running) return;
    this.running = false;
    if (this.animId) cancelAnimationFrame(this.animId);
    audio.playRomanticChime();
    this.container.innerHTML = `
      <div style="background:#1b0d2a; color:#ffd166; height:100%; display:flex; flex-direction:column; justify-content:center; align-items:center;">
        <h2 style="color:#ff70a6; margin-bottom:12px;">💖 HEART FOUND!</h2>
        <p style="color:#eee; margin-bottom:16px;">"Anything that comes in our way, we turn into our way."</p>
        <span style="color:#a78bfa;">Emily is now active on Messenger!</span>
      </div>
    `;
    setTimeout(() => {
      if (this.onComplete) this.onComplete();
    }, 1500);
  }

  destroy() {
    this.running = false;
    if (this.animId) cancelAnimationFrame(this.animId);
  }
}
